// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6\\+bDK {\n  position: relative;\n  padding: var(--space-100);\n  border-radius: var(--radius-75);\n}\n\n._6\\+bDK:hover {\n    background-color: var(--surface-brand-hover);\n  }\n\n.ehLm9 {\n  position: absolute;\n  top: -1px;\n  right: -2px;\n  z-index: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_6+bDK",
	"badge": "ehLm9"
};
export default ___CSS_LOADER_EXPORT___;
